import {
  EntityEditHandler,
  type MoveParams,
} from '@/plugins/cad/module/CADModule/edit/EntityEditHandler'
import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'

/**
 * 移动实体命令，按平移向量原地修改实体并支持撤销。
 */
export class MoveEntityCommand extends Command {
  private entities: IEntity[]
  private params: MoveParams
  private viewManager: CADViewManager

  constructor(entities: IEntity[], params: MoveParams, viewManager: CADViewManager) {
    super()
    this.entities = entities
    this.params = params
    this.viewManager = viewManager
  }

  /** 对所有实体执行平移并刷新几何体 */
  execute(): void {
    EntityEditHandler.move(this.entities, this.params)
    this.viewManager.updateEntities(this.entities, { updateGeometry: true })
  }

  /** 撤销：按反向向量恢复实体原位置 */
  undo(): void {
    const reverseTranslate = {
      x: -this.params.translate.x,
      y: -this.params.translate.y,
    }
    EntityEditHandler.move(this.entities, { translate: reverseTranslate })
    this.viewManager.updateEntities(this.entities, { updateGeometry: true })
  }
}
